<mat-tab-group>
    <mat-tab label="Délégués">
      <ng-template mat-tab-label>
        <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
 
        Délégués
      </ng-template>
      
      <app-delegate-reporting></app-delegate-reporting> </mat-tab>
    <mat-tab label="Sonatrach">
      <ng-template mat-tab-label>
        <img width="30" src="assets/img/icontab/sh.png" alt="" srcset="">
 
        Sonatrach
      </ng-template>


      <app-sonatrach></app-sonatrach> </mat-tab>
    <mat-tab label="Speakers">
      <ng-template mat-tab-label>
        <img width="30" src="assets/img/icontab/speaker.png" alt="" srcset="">
 
        Speakers
      </ng-template>
      
      <app-speaker></app-speaker> 
    </mat-tab>
    
 
  </mat-tab-group>
